var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuestic-progress-bar" },
    [
      _vm.type == "horizontal"
        ? _c("horizontal-bar", {
            attrs: {
              value: _vm.transformedValue,
              text: _vm.text,
              size: _vm.size,
              disabled: _vm.disabled,
              animated: _vm.animated,
              theme: _vm.theme,
            },
          })
        : _vm._e(),
      _vm.type == "vertical"
        ? _c("vertical-bar", {
            attrs: {
              value: _vm.transformedValue,
              text: _vm.text,
              size: _vm.size,
              disabled: _vm.disabled,
              animated: _vm.animated,
              theme: _vm.theme,
            },
          })
        : _vm._e(),
      _vm.type == "circle"
        ? _c("circle-bar", {
            attrs: {
              value: _vm.transformedValue,
              text: _vm.text,
              disabled: _vm.disabled,
              animated: _vm.animated,
              theme: _vm.theme,
              "background-theme": _vm.backgroundTheme,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }